/** se quiser testar localmente as notificações, descomente as linhas abaixo */
// export const APP_URL_HERMES = 'https://magos.hermes.empreender.plus';
// export const PUSHER_APP_KEY_HERMES = 'hermes-magos';
// export const PUSHER_HOST_HERMES = 'soketihermes.stgmagos.empreender.app';

export const APP_URL_HERMES = 'https://hermes.empreender.plus';
export const PUSHER_APP_KEY_HERMES = 'hermes-prod';
export const PUSHER_HOST_HERMES = 'ws.hermes.empreender.plus';
